import { render, staticRenderFns } from "./client-create.vue?vue&type=template&id=7ca20cbb&"
import script from "./client-create.vue?vue&type=script&lang=js&"
export * from "./client-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports